import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HeaderComponent } from './core/composants/header/header.component';
import { FooterComponent } from './core/composants/footer/footer.component';
import { InformationSliderComponent } from './information-slider/information-slider.component';
import { HomeComponent } from './home/home.component';
import { TasksComponent } from './tasks/tasks.component';

/*import { ContactComponent } from './home/contact/contact.component';
import { ModifyUserAdminComponent } from './modify-user-admin/modify-user-admin.component';
import { AlertComponent } from './alert/alert.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { SortDirective } from './directive/sort.directive';
import { TwoDigitDecimaNumberDirective } from './directive/TwoDigitDecimaNumber.directive';
import { SettingsComponent } from './settings/settings.component';
import { HttpErrorInterceptor } from './interceptors/error-interceptor';
import { ExcelService } from './services/excel.service';
import { ViewUserDeletedComponent } from './view-user-deleted/view-user-deleted.component';
import { CanDeactivateGuard } from './services/auth-guard.service';
import { CollabBoardComponent } from './collab-board/collab-board.component';
import { InsertCompconfFileComponent } from './insert-compconf-file/insert-compconf-file.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ViewCompconfsComponent } from './view-compconfs/view-compconfs.component';

import { CreateReclamationComponent } from './create-reclamation/create-reclamation.component';
import { AddPotifRecComponent } from './add-potif-rec/add-potif-rec.component';
import { TimerComponent } from './timer/timer.component';
import { DetailrecComponent } from './detailrec/detailrec.component';
import { DocumentAdminComponent } from './document-admin/document-admin.component';
import { ViewDocumentComponent } from './view-document/view-document.component';*/

//Angular material
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatBadgeModule } from '@angular/material/badge';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { AuthModule } from './modules/auth/auth.module';
import { ReclamationModule } from './modules/reclamation/reclamation.module';
import { TransactionModule } from './modules/transaction/transaction.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    InformationSliderComponent,
    HomeComponent,
    TasksComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatDividerModule,
    MatCardModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MatBadgeModule,
    MatExpansionModule,MatSnackBarModule,
    MatSlideToggleModule,MatCheckboxModule,MatDatepickerModule,MatFormFieldModule,MatNativeDateModule,MatGridListModule,MatSidenavModule,MatListModule,MatPaginatorModule,
    ModalModule.forRoot(),
    AuthModule,
    ReclamationModule,
    TransactionModule,
    DashboardModule, 
    CoreModule,
    SharedModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
